var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInManufacturing = function SvgInManufacturing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0.71 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#in-manufacturing_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.834 10.241.69-7.248H6.69l.582 6.1m-6.058 6.4h15v-7.76a.74.74 0 0 0-.924-.715L1.714 10.534a.67.67 0 0 0-.499.646v4.313ZM6.051.586c.688-.012 1.37.13 1.997.414 4.952 2.115 7-.493 7-.493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.881 15.494h-3.333v-3a.667.667 0 0 1 .666-.666h2a.667.667 0 0 1 .667.666zm-5.667-2.667h-1m-2.333 0h-1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "in-manufacturing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.714 0h16v16h-16z"
  })))));
};
export default SvgInManufacturing;